import { PlannerEcsMultiSystem, ProductInfoComponent, ProductType } from '@inter-ikea-storageone/range';
import { BestaLegsComponent } from '../components/BestaLegsComponent';
import { FrameSelectedLegComponent } from '../components/FrameSelectedLegComponent';
/**
 * A very simple system with just one job: When a new BESTÅ frame is created, it will add a component with the
 * leg data for currently selected leg type to that frame
 */
export class BestaFrameSetLegsOnCreatedSystem extends PlannerEcsMultiSystem {
    constructor(coreApi, selectedLeg) {
        super(coreApi, 'BestaFrameSetLegsOnCreatedSystem', [
            ProductInfoComponent.id,
            FrameSelectedLegComponent.id
        ]);
        this.setLeg(selectedLeg);
    }
    setLeg(newComponent) {
        this._selectedLeg = newComponent.legProductRef;
        this._useSupport = newComponent.useSupportLeg;
    }
    onAdd(entity, newComponent) {
        switch (newComponent.typeId) {
            case ProductInfoComponent.id:
                if ([
                    ProductType.BESTA_FRAME_600_ASM,
                    ProductType.BESTA_FRAME_1200_ASM,
                    ProductType.BESTA_TV_BENCH_1200_ASM,
                    ProductType.BESTA_TV_BENCH_1800_ASM
                ].includes(newComponent.productType)) {
                    entity.addComponent(new BestaLegsComponent(false, null, null, this._selectedLeg ? this._selectedLeg : 'pFramePad', this._useSupport ? this._useSupport : false));
                }
                break;
            case FrameSelectedLegComponent.id:
                this.setLeg(newComponent);
                break;
        }
    }
    onUpdate(entity, oldComponent, newComponent) {
        switch (newComponent.typeId) {
            case FrameSelectedLegComponent.id:
                this.setLeg(newComponent);
                break;
        }
    }
    onRemove() { }
}
//# sourceMappingURL=BestaFrameSetLegsOnCreatedSystem.js.map